import React, { Component } from 'react';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {  Col, Card, CardBody, Button, Row } from 'reactstrap';
import MultiSelect from "../../../components/ReusableComponents/MultiSelect/index";
import{listCorporate, reportByDate} from "./Action"
import withAuth from '../../../components/Services/WithAuth';
import '../../../app.scss';
import AuthService from '../../../components/Services/AuthService';
import fileSaver from 'file-saver';
import { Preloading } from '../../../components/UI/Preloader/action';
import Select from 'react-select';
import { toast } from 'react-toastify';

class MeteringStats extends Component {
    constructor(props) {
      super(props);
      this.state = {
        corporateList: [],
        loading: true,
        toDate: null,
        fromDate: null,
        body: null,
        requestBody: [],
        selectedEntityData:[],
      };
      this.refreshInterval = null
      this.Auth = new AuthService();
    }

    handleFromDateChange(date){
      this.setState({fromDate:date});
      
    }

    handleToDateChange(date){
      this.setState({toDate:date});
    }

    downloadReportByDate(){
      this.props.preloading(true);
      const requestBody ={
        startDate : this.state.fromDate.format('DD-MMM-YYYY'), 
        endDate:this.state.toDate.format('DD-MMM-YYYY'), 
        corporateId:this.state.selectedEntityData.value
      }
      this.props.reportByDate(requestBody)
    }

    componentDidMount() {
      this.props.preloading(true);
        const requestBody = {
          corporateName: ""
        }
        this.props.listCorporate(requestBody)
      }

    selectedEntityCallback = (selectedData) => {
        this.setState({
            selectedEntityData: selectedData
        })
    }

    componentDidUpdate(prevProps) {
        const { corporateList, corporateListFailure, excelReportByDate, downloadExcelFile, excelReportData, reportByDateFailure} = this.props
        if (corporateList !== prevProps.corporateList) {
          let corporateListArray=[]
          corporateList.forEach(item=>corporateListArray.push({ value: item.id, label: item.name })) 
          this.setState({
            corporateList: corporateListArray,
            loading: false
          })
          this.props.preloading(false);
        }
        if (corporateListFailure !== prevProps.corporateListFailure) {
          if (corporateListFailure === false) {
            this.props.history.push('/error-page');
          }
          this.props.preloading(false);
        }
        if(excelReportByDate !== prevProps.excelReportByDate){
          const data = excelReportByDate;
            let blob = new Blob([data],  {type: "application/octet-stream"});
            fileSaver.saveAs(blob, `Metering_Stats_${moment().format("DD_MMM_YYYY")}.xlsx`);
            this.props.preloading(false);
        }
      if (reportByDateFailure !== prevProps.reportByDateFailure) {
        toast.error(
          <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp; {reportByDateFailure.data}
          </div>
        );
      }
    }

    

    render(){
        return (
            <Col>
                <Card>
                    <CardBody>
                    <Row className="mb-3 align-items-center">
                                                                                  
                    <Col xs="3" className="filter-category py-0 py-sm-20">
                        <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">{"Corporate Name"}</span>
                    </Col>
                    <Col sm="9" className="filter-category py-sm-20">
                        <Select 
                        value={this.state.selectedEntityData}
                        onChange={this.selectedEntityCallback}
                        options={this.state.corporateList} 
                        >
                        </Select>
                    </Col>
                    <Col xs='2'>
                        <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">{'Created on'}</span>
                    </Col>
                    <Col sm="8">
                        <div className="d-flex align-items-center">
                            <DatePicker className="form-control" selected={(this.state.fromDate!==null) ? (this.state.fromDate) : null} onChange={(date)=>this.handleFromDateChange(date)} placeholderText="From date DD-MMM-YYYY" dateFormat="dd-MMM-YYYY" maxDate={(this.state.toDate!==null) ? this.state.toDate : moment(new Date())} />
                            <span><i className="icon-minus text-dark"></i></span>
                            <DatePicker className="form-control" selected={(this.state.toDate!==null) ? (this.state.toDate) : null} onChange={(date)=>this.handleToDateChange(date)} placeholderText="To date DD-MMM-YYYY" dateFormat="dd-MMM-YYYY" minDate={(this.state.fromDate!==null) ? this.state.fromDate : null} />
                        </div>
                        <div>
                            <span className="text-danger">{this.state.errorMsg}</span>
                        </div>
                    </Col>
                    </Row>
                    <Row>
                        <Col className="downloadExcelBtn" sm="24">
                        <Button class="btn btn-primary" color="primary" disabled = {(this.state.selectedEntityData && this.state.fromDate && this.state.toDate) ? false : true} 
                        onClick={()=>this.downloadReportByDate()}>Download Excel</Button>
                        </Col>
                    </Row>
                    </CardBody>
                </Card>
            </Col>
            
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    corporateNameList: state.cases.corporateNameList,
    corporateNameListFailure: state.cases.corporateNameListFailure,
    corporateList : state.meteringStatsCorporateListData.corporateList,
    corporateListFailure: state.meteringStatsCorporateListData.corporateListError,
    excelReportByDate : state.meteringStatsCorporateListData.reportByDate,
    reportByDateFailure : state.meteringStatsCorporateListData.reportByDateError
  })
  
  const mapDispatchToProps = (dispatch) => ({
    listCorporate:()=>{dispatch(listCorporate())},
    reportByDate:(data)=>{dispatch(reportByDate(data))},
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
  });
  export default withAuth(connect(mapStateToProps, mapDispatchToProps)(MeteringStats))